import request from 'app/common/request/simple-request';
import { ChallengeType, SharingAccessErrorCode } from './types';

type ValidateSecureSharingAccessParams = {
  linkGuid: string;
  challengeType: ChallengeType;
  challengeInput: string;
};

type ValidateSecureSharingAccessRequestParams = {
  SharingLinkGuid: string;
  PassCode?: string;
  Email?: string;
};

export type ValidateSecureSharingAccessError = {
  errorCode: SharingAccessErrorCode;
  errorTitle: string;
};

type ValidateSecureSharingAccessResponse = {
  RedirectUrl: string;
};

const api = {
  validateSecureSharingAccess(params: ValidateSecureSharingAccessParams) {
    const { linkGuid, challengeType, challengeInput } = params;

    if (challengeType === ChallengeType.Email) {
      const data = { SharingLinkGuid: linkGuid, Email: challengeInput };

      return request.post<
        ValidateSecureSharingAccessRequestParams,
        ValidateSecureSharingAccessError | undefined
      >('/_mvc/share/RequestEmailVerification', data);
    }

    const data = { SharingLinkGuid: linkGuid, PassCode: challengeInput };

    return request.post<
      ValidateSecureSharingAccessRequestParams,
      ValidateSecureSharingAccessError | ValidateSecureSharingAccessResponse
    >('/_mvc/share/validate', data);
  },
};

export default api;
